import React, { useState } from 'react';
import { Countdown, Button, TrustBar } from './Shared';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
type Option = {
  id: string;
  icon: string;
  name: string;
  detail: string;
  oldPrice: string;
  price: string;
  cta: string;
  href: string;
  top?: boolean;
  save?: string;
};
const OPTIONS: Option[] = [{
  id: 't1',
  icon: '📘',
  name: 'PACK TRAMO 1 · Inicial',
  detail: '8 tomos + 6 bonos + 400 actividades',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 1 →',
  href: 'https://tufenixdigital.store/cart/53832899985772:1',
  save: 'AHORRÁS $1.100'
}, {
  id: 't2',
  icon: '📗',
  name: 'PACK TRAMO 2 · 1° y 2°',
  detail: '8 tomos + 6 bonos + 400 actividades',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 2 →',
  href: 'https://tufenixdigital.store/cart/53939688046956:1',
  save: 'AHORRÁS $1.100'
}, {
  id: 'mega',
  icon: '🏆',
  name: 'MEGAPACK AULA DE EXITOS BUSINESS',
  detail: '32 tomos + 24 bonos + 1.600 actividades +🔑 Un negocio llave en mano, listo para empezar. 🚀',
  oldPrice: '$7.960',
  price: '$2.490',
  cta: '⭐ QUIERO EL MEGAPACK AHORA 📲',
  href: 'https://tufenixdigital.store/cart/53889590722924:1',
  top: true,
  save: 'AHORRÁS $5.470'
}, {
  id: 't3',
  icon: '📙',
  name: 'PACK TRAMO 3 · 3° y 4°',
  detail: '8 tomos + 6 bonos + 400 actividades',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 3 →',
  href: 'https://tufenixdigital.store/cart/53939663012204:1',
  save: 'AHORRÁS $1.100'
}, {
  id: 't4',
  icon: '📓',
  name: 'PACK TRAMO 4 · 5° y 6°',
  detail: '8 tomos + 6 bonos + 400 actividades',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 4 →',
  href: 'https://tufenixdigital.store/cart/53939690602860:1',
  save: 'AHORRÁS $1.100'
}];
export function Precios() {
  const [selected, setSelected] = useState('mega');
  const shouldReduceMotion = useReducedMotion();
  const current = OPTIONS.find(o => o.id === selected) ?? OPTIONS[2];
  return <>
      {/* SECCIÓN 6: URGENCIA */}
      <section className="py-12 px-4 bg-[#FFF6F0] border-y border-orange-100 text-center" data-id="element-113" data-mp="2erzinbza12s8">
        <div className="max-w-3xl mx-auto" data-id="element-114" data-mp="2jrc5hwq5e9ut">
          <div className="inline-block bg-[#FFE4E6] text-[#E11D48] px-4 py-1.5 rounded-full text-sm font-bold mb-6 flex items-center justify-center gap-2 w-max mx-auto shadow-sm" data-id="element-115" data-mp="2jqaprey6sz6r">
            <span className="w-2 h-2 rounded-full bg-[#E11D48] animate-pulse" data-id="element-116" data-mp="2sje1nit6p3za"></span>
            Cupos limitados · Quedan pocos
          </div>
          <h2 className="text-2xl md:text-3xl font-display font-bold text-brand-deep mb-8 flex items-center justify-center gap-2" data-id="element-117" data-mp="2xl3hdbrcq5tp">
            <span className="text-3xl" data-id="element-118" data-mp="37hznjats2fv3">⏰</span> PRECIO DE LANZAMIENTO TERMINA EN:
          </h2>
          <Countdown data-id="element-119" data-mp="184vkt8tzhsom" />
          <p className="text-lg text-brand-text font-medium mt-8" data-id="element-120" data-mp="185dogqiz796k">
            Después vuelve a su precio real y no vuelve esta oferta.
          </p>
        </div>
      </section>

      {/* SECCIÓN 7: PRECIOS */}
      <section id="precios" className="py-16 px-4 bg-brand-base scroll-mt-10" data-id="element-121" data-mp="3qf9mydtqliik">
        <div className="max-w-xl mx-auto" data-id="element-122" data-mp="3llxb74a5p678">
          <div className="text-center mb-10" data-id="element-123" data-mp="3lkvou3nowxa7">
            <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-deep mb-3" data-id="element-124" data-mp="3hklkswjgkgxz">
              ELEGÍ TU <span className="text-brand-orange" data-id="element-125" data-mp="3cncyqkv6vsrg">AULA DE ÉXITOS</span>
            </h2>
            <p className="text-lg text-brand-text font-medium" data-id="element-126" data-mp="d7omw8eo31kv">
              Todas las opciones incluyen los tomos completos · los 6 bonos
              estratégicos y 400 actividades listas para usar.
            </p>
          </div>

          {/* Selectable rows */}
          <div role="radiogroup" aria-label="Opciones de compra" className="space-y-4 mb-8" data-id="element-127" data-mp="48bbha6zg2xi">
            {OPTIONS.map(opt => {
            const isActive = selected === opt.id;
            return <button key={opt.id} type="button" role="radio" aria-checked={isActive} onClick={() => setSelected(opt.id)} className={`relative w-full text-left rounded-2xl p-4 md:p-5 border-2 transition-all flex items-center gap-4 ${isActive ? 'border-brand-orange bg-orange-50 shadow-[0_8px_24px_rgba(245,124,0,0.18)]' : 'border-gray-200 bg-white hover:border-brand-sky'}`} data-id="element-128" data-mp="2oumqalmhvrlx">
                  {/* TOP badge */}
                  {opt.top && <span className="absolute -top-3 right-4 bg-brand-orange text-white text-xs font-bold px-3 py-0.5 rounded-full shadow-md" data-id="element-129" data-mp="7n37ee30d4dw">
                      ⭐ TOP
                    </span>}

                  {/* Radio */}
                  <span className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${isActive ? 'border-brand-orange' : 'border-gray-300'}`} data-id="element-130" data-mp="zdhf1skfhkh4">
                    {isActive && <span className="w-3 h-3 rounded-full bg-brand-orange" data-id="element-131" data-mp="qd1f2t2w8vh0" />}
                  </span>

                  {/* Label */}
                  <div className="flex-1 min-w-0" data-id="element-132" data-mp="363dwxsj0htte">
                    <div className="font-display font-bold text-brand-deep text-base md:text-lg flex items-center gap-2 flex-wrap" data-id="element-133" data-mp="3b3s1v1pbgnn7">
                      <motion.span className="text-xl inline-block" animate={shouldReduceMotion || !isActive ? undefined : {
                    rotate: [0, -5, 5, 0],
                    y: [0, -1, 0]
                  }} transition={{
                    duration: 2.8,
                    repeat: Infinity,
                    repeatDelay: 3,
                    ease: 'easeInOut'
                  }} data-id="element-134" data-mp="33j7r1fau7ta7">
                        {opt.icon}
                      </motion.span>
                      <span data-id="element-135" data-mp="2fvr8h4ddjcwg">{opt.name}</span>
                    </div>
                    <div className="text-sm text-brand-text mt-0.5" data-id="element-136" data-mp="2tmctayme1wwz">
                      {opt.detail}
                    </div>
                    {opt.save && <span className="inline-block mt-2 bg-brand-greenSoft text-brand-green border border-green-200 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-137" data-mp="2oulbbchaszig">
                        🟢 {opt.save}
                      </span>}
                  </div>

                  {/* Price + Mini CTA (lado derecho) */}
                  <div className="flex-shrink-0 text-right flex flex-col items-end" data-id="element-138" data-mp="31apqxqmv50">
                    <div className="text-brand-gray line-through text-sm font-medium" data-id="element-139" data-mp="51vscpjyydnj">
                      {opt.oldPrice}
                    </div>
                    <div className="font-display font-bold text-brand-deep text-2xl md:text-3xl" data-id="element-140" data-mp="9w003b126ppo">
                      {opt.price}
                    </div>
                    <div className="text-xs text-brand-gray font-semibold" data-id="element-141" data-mp="3dbnuep7w36w1">
                      UY
                    </div>

                    {/* Mini CTA por oferta */}
                    <motion.a href={opt.href} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="mt-3 inline-flex items-center gap-1 bg-brand-orange hover:bg-[#EF6C00] text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-sm transition-colors whitespace-nowrap" animate={shouldReduceMotion || !isActive ? undefined : {
                  scale: [1, 1.035, 1]
                }} transition={{
                  duration: 2.6,
                  repeat: Infinity,
                  repeatDelay: 2,
                  ease: 'easeInOut'
                }} whileHover={shouldReduceMotion ? undefined : {
                  scale: 1.05
                }} whileTap={{
                  scale: 0.97
                }} data-id="element-142" data-mp="3n8af9e07txy2">
                      Lo quiero ahora!
                      <motion.span animate={shouldReduceMotion || !isActive ? undefined : {
                    x: [0, 2, 0]
                  }} transition={{
                    duration: 1.6,
                    repeat: Infinity,
                    repeatDelay: 2,
                    ease: 'easeInOut'
                  }} className="inline-flex" data-id="element-143" data-mp="28bz2y84vxguu">
                        <ArrowRight className="w-3 h-3" data-id="element-144" data-mp="1udj04sa58ahz" />
                      </motion.span>
                    </motion.a>
                  </div>
                </button>;
          })}
          </div>

          {/* Dynamic CTA */}
          <motion.div key={current.id} initial={{
          opacity: 0.6
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.2
        }} data-id="element-145" data-mp="2xkd3viy8zgb4">
            <Button href={current.href} variant={current.id === 'mega' ? 'success' : 'primary'} className="py-5 text-lg md:text-xl" data-id="element-146" data-mp="32liyjmbgxdna">
              {current.cta}
            </Button>
          </motion.div>

          

          <div className="mt-6" data-id="element-147" data-mp="2etvftrod18w3">
            <TrustBar data-id="element-148" data-mp="2etly0rdgy81h" />
          </div>

          <div className="mt-16 bg-white p-8 rounded-3xl border border-brand-sky shadow-sm" data-id="element-149" data-mp="2eskfk1u4ij9q">
            <h3 className="text-2xl font-display font-bold text-brand-deep mb-6 text-center" data-id="element-150" data-mp="2iws5u3g8c7a2">
              Por qué el MegaPack AULA DE EXITOS BUSINESS es la decisión más
              inteligente
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-151" data-mp="29wvchoiwak8o">
              <div className="p-5 bg-gray-50 rounded-xl border border-gray-200" data-id="element-152" data-mp="35cnq5gwfu53">
                <p className="font-bold text-brand-deep mb-2" data-id="element-153" data-mp="83nwecvgjylq">
                  SI COMPRÁS UN TRAMO POR $890 ·
                </p>
                <p className="text-sm text-brand-text" data-id="element-154" data-mp="1slydlzxe7eks">
                  Tenés el año resuelto, es una solución puntual para ese tramo,
                  pensada para quienes no necesitan una propuesta más amplia.
                </p>
              </div>
              <div className="p-5 bg-brand-lightBlue rounded-xl border border-brand-sky" data-id="element-155" data-mp="1xkt4lp5ik9fz">
                <p className="font-bold text-brand-blue mb-2" data-id="element-156" data-mp="2bbo80lx8tyc6">
                  SI COMPRÁS EL MEGAPACK AULA DE EXITO BUSINESS POR $2.490 ·
                </p>
                <p className="text-sm text-brand-text font-[600]" data-id="element-157" data-mp="26cldhvew3aig">
                  Tenés toda la primaria uruguaya cubierta. Podés atender a
                  cualquier niño sin importar el año que curse. Nunca más tenés
                  que decirle "no" a un padre porque no tenés material de ese
                  tramo. Recuperás la inversión en 4 horas de clases. A partir
                  de la quinta hora todo es ganancia pura, de por vida.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}